import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  isDevMode,
  importProvidersFrom,
  APP_INITIALIZER,
} from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { Auth } from '@angular/fire/auth';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { Store } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DEFAULT_LOCALE } from './core/constants/locale.constants';
import { TranslateStaticLoader } from './core/i18n/translate-static.loader';
import { appRoutes } from './app.routes';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { firebaseConfig } from './config/firebase.config';
import { authReducer } from './core/store/auth/auth.reducer';
import { AuthEffects } from './core/store/auth/auth.effects';
import { tenantReducer } from './core/store/tenant/tenant.reducer';
import { TenantEffects } from './core/store/tenant/tenant.effects';
import { notificationsReducer } from './core/store/notifications/notifications.reducer';
import { NotificationsEffects } from './core/store/notifications/notifications.effects';
import { InviteFlowService } from './core/services/invite-flow.service';
import { authInitializer } from './core/auth/auth.initializer';
import { LucideIconsModule } from './core/icons/lucide-icons.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    {
      provide: APP_INITIALIZER,
      useFactory: authInitializer,
      deps: [Auth, Store, InviteFlowService],
      multi: true,
    },
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([tenantInterceptor, authInterceptor, errorInterceptor])),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideStore({ auth: authReducer, tenant: tenantReducer, notifications: notificationsReducer }),
    provideEffects([AuthEffects, TenantEffects, NotificationsEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: DEFAULT_LOCALE,
        loader: {
          provide: TranslateLoader,
          useClass: TranslateStaticLoader,
        },
      }),
      LucideIconsModule
    ),
  ],
};
